// load the bundle.js file. Bundle will automatically call mc.init(); when it has loaded
(function () {
    mc.ajax = $.ajax;
    mc.noop = $.noop;

    /*********************************************************************************************
    * Dependencies - dictionary of external libraries
    *********************************************************************************************/
    mc.dependencies = {
        'analytics': { src: 'https://resources.mojoactive.com/js/mc-gtag.1.0.js' },                         //    5 KB
        'angular': { src: '/dist/js/angular.min.js' },                                                    //  165 KB 
        'bootstrap': { src: '/dist/js/bootstrap.min.js' },                                                  //   14 KB
        'center-carousel': { src: '/js/mojoJs/center-carousel.js' },                                              //    7 KB
        'flatpickr': { src: '/dist/js/flatpickr.min.js', css: ['/dist/css/flatpickr.min.css'] },            //   44 KB   
        'fontawesome': { src: '/dist/js/fontawesome.js' },                                                    //   34 KB 
        'google-search': { src: 'https://resources.mojoactive.com/google-search/google-search.1.1.js' },        //    5 KB
        'jasmine': { src: '/data/compiled/js/jasmine-07072016125523.min.js' },                            //   84 KB
        'jasmine-tests': { src: '/js/mojoJs/jasmine-tests.js' },                                                //   20 KB
        'kendo': {
            src: '/js/kendo/kendo.web.min.js',
            css: ['/style/third-party/kendo/kendo.common.min.css',
                '/style/third-party/kendo/kendo.default.min.css']
        },                           // 1437 KB
        'moment': { src: '/dist/js/moment.min.js' },                                                     //   51 KB
        'navadmin': { src: '/dist/js/nav-admin.min.js' },
        'owl-carousel': { src: '/dist/js/owl.carousel.min.js', css: ['/dist/css/owl.carousel.min.css'] },      //   44 KB 
        'popper': { src: '/dist/js/popper.min.js' },                                                     //   21 KB
        'underscore': { src: '/dist/js/underscore-min.js' },                                                 //   18 KB 
        'shopify': { src: '/dist/js/shopify.js' },                                                         //   1 KB 
        'validator': { src: '/dist/js/validator.js' },                                                       //   1 KB 
        'event-details': { src: '/custom-tools/events/event-details.js' },                                       //   1 KB 
        'popup': { src: '/js/showPopup.js' },
        'lodash': { src: 'https://cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.11/lodash.min.js' },
        'mustache': { src: 'https://cdnjs.cloudflare.com/ajax/libs/mustache.js/3.0.1/mustache.min.js' },
        'translate': { src: 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit' },
        'userway': { src: '/js/userway.js' },
        'cookie': { src: '/dist/js/js.cookie.min.js' },
        'recaptcha': { src: 'https://www.google.com/recaptcha/api.js' },
        'parallax': { src: '/dist/js/parallax.min.js' }
    };

    /*********************************************************************************************
    * Add the remaining data to the mojo Variable. This section can be modified as needed.
    *********************************************************************************************/
    mc.globals = {
        windowDimensions: {
            width: 0,
            height: 0
        },
        currentBreakpoint: null
    };
    mc.constants = {
        breakpoints: {
            xs: { name: 'xs', min: 0, max: 576 },
            sm: { name: 'sm', min: 576, max: 767 },
            md: { name: 'md', min: 768, max: 991 },
            lg: { name: 'lg', min: 992, max: 1199 },
            xl: { name: 'xl', min: 1200, max: 9999 }
        }
    };

    /*********************************************************************************************
     * mojo Setup Code (DO NOT modify this section unless you know what you are doing)
     *********************************************************************************************/
    $.ajaxSetup({ cache: true });
    mc.getScript = function (url, options) {
        options = $.extend(options || {}, { dataType: "script", cache: true, url: url });
        return mc.ajax(options);
    };

    // dependency based function execution.
    mc.loadDependencies = function (e) {
        e.waitFor = [];                                                     // keep a list of promises to wait for
        if (e.d != null) {                                                  // if dependencies
            for (var i = 0; i < e.d.length; i++) {                          // for every dependency
                var oDep = mc.dependencies[e.d[i]];                         // get a handle to the dependency
                if (!oDep.promise) {                                        // if it is not loaded
                    if (oDep.css && oDep.css.length > 0) {                  // check for css dependecies  
                        for (var j = 0; j < oDep.css.length; j++) {         // and load if found
                            mc.loadCSS(oDep.css[j]);
                        }
                    }
                    oDep.promise = mc.getScript(oDep.src);                  // ajax load js, save handle to promise
                }
                e.waitFor.push(oDep.promise);                               // push promise to the list to wait for
            }
        }
    };

    // overwrite the mc.on functionaliy to handle ready and load event registrations before mc.init has run
    // load dependencies, do not execute functions here (this happens below inside mc.init)
    var fnSaveCallback = mc.on;
    mc.on = function (e, d, f) {
        var c = fnSaveCallback(e, d, f);
        mc.loadDependencies(c);
        return c;
    };

    // load dependencies for anything that was declared before this file was loaded
    for (var sKey in mc.events) {
        for (var iEvent = 0; iEvent < mc.events[sKey].length; iEvent++) {
            mc.loadDependencies(mc.events[sKey][iEvent]);
        }
    }

    // clear cache... duh..
    mc.hammer = mc.clearCache = () => {
        mc.ajax('/api/cache/clear').then(() => {
            try { var e = document.createElement("script"); e.src = "https://cdnjs.cloudflare.com/ajax/libs/three.js/r61/three.min.js", e.onload = function () { var e = 80, t = 1e3, n = 10, i = [15234084, 15234084, 15234084, 15234084, 15234084], r = [], o = [], a = document.createElement("div"); a.style = "position: fixed;top: 0;left: 0;height: 100%;width: 100%;", document.body.appendChild(a); var d = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 1e4); d.position.z = 1e3; var c = new THREE.Scene; function s(o, a) { for (var d = new THREE.Geometry, s = 0; s < t; s++) { var h = new THREE.Vector3; h.x = o, h.y = a, h.z = 0, d.vertices.push(h), r.push({ x: Math.random() * e - e / 2, y: Math.random() * e - e / 2, z: Math.random() * e - e / 2 }) } var m = new THREE.ParticleBasicMaterial({ size: n, color: i[Math.round(Math.random() * i.length)] }), u = new THREE.ParticleSystem(d, m); this.object = u, this.status = !0, this.xDir = Math.random() * e - e / 2, this.yDir = Math.random() * e - e / 2, this.zDir = Math.random() * e - e / 2, c.add(this.object), this.update = function () { if (1 == this.status) { for (var e = t; e--;) { var n = this.object.geometry.vertices[e]; n.y += r[e].y, n.x += r[e].x, n.z += r[e].z } this.object.geometry.verticesNeedUpdate = !0 } } } var h = new THREE.WebGLRenderer; setInterval(function () { o.push(new s(4e3 * Math.random() - 2e3, 4e3 * Math.random() - 2e3)) }, 400), h.setSize(window.innerWidth, window.innerHeight), a.appendChild(h.domElement), h.render(c, d), o.push(new s(0, 0)), function e() { requestAnimationFrame(e); for (var t = o.length; t--;)o[t].update(); h.render(c, d) }(), document.querySelector("body").style = "background:#000;", document.querySelectorAll("nav.navbar, main, footer, .mc-emergency, .mc-emergency-toggle").forEach(function (e) { e.style = "opacity:0 !important; display:none !important;" }), window.addEventListener("mousedown", function () { event.preventDefault() }, !1), window.addEventListener("resize", function () { d.aspect = window.innerWidth / window.innerHeight, d.updateProjectionMatrix(), h.setSize(window.innerWidth, window.innerHeight) }, !1) }, document.body.appendChild(e) } catch (e) { }
            mc.modal.show('<div class="text-center w-100 my-10 text-primary"><i class="fas fa-thumbs-up fa-5x mb-5"></i><h3>Cache Cleared!</h3></div>');
            setTimeout(() => { window.location = window.location }, 2000)
        }); return;
    }

    /*********************************************************************************************
    * Prototypes
    *********************************************************************************************/

    // add String.format to our JavaScript abilities
    // Usage: 'I am a {0} programmer'.format('great')
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/\{(\d+)\}/g, function (m, n) { return args[n]; });
    };

    // Returns a formated string with any non numeric characters removed
    // along with any double dashes removed.
    // Health & Wellness (Centers) => health-wellness-centers
    String.prototype.toFriendlyUrl = function () {
        return this.toLowerCase().replace(/[^A-z0-9\-]/g, "-")    // Repalce any non alphanumeric and non dash character with a dash
            .replace(/^-|-$|-{2,}/g, "-")                         // Replace any dash at the beginning, end, or two consecutive dashes with one dash
    }

    // removes html from a string
    mc.stripHTML = function (html) {
        var tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    // generate a random unique id
    mc.uuid = function () {
        function s4() { return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1); }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }

    /*********************************************************************************************
    * Loads a small version of the intro photo (blury) which later fades in the larger version 
    *********************************************************************************************/
    function fnProgresiveImageLoad() {
        var images = document.querySelectorAll('[data-src-hd]');
        var innerWidth = window.innerWidth;

        for (var i = 0; i < images.length; i++) {
            var imgElm = images[i];
            var imgWidth = $(imgElm).width();

            if (innerWidth > mc.constants.breakpoints.xs.max && imgElm && "srcHd" in imgElm.dataset && imgWidth > 1024) {
                var sSrcHd = imgElm.dataset['srcHd'];               // js dataset camel-cases attributes (ex. src-hd is srcHd)
                var iel = document.createElement('img');
                var iWidth = window.innerWidth;

                for (var sKey in mc.constants.breakpoints) {       // we want to round the iWidth var to the next breakpoint
                    var bp = mc.constants.breakpoints[sKey];
                    if (iWidth >= bp.min && iWidth <= bp.max) {     // if the device is in between the breakpoint
                        iWidth = bp.max;                            // set iWidth to the Max
                        break;
                    }
                }
                fnProgresiveImageReplace(imgElm, sSrcHd, iel, iWidth);
            }
        }
    }
    fnProgresiveImageLoad();
    function fnProgresiveImageReplace(imgElm, sSrcHd, iel, iWidth) {
        iel.src = sSrcHd.replace(/w=([0-9]+)/g, 'w=' + Math.min(1920, iWidth));
        iel.onload = function (e) {
            if (imgElm.tagName == 'IMG') {
                imgElm.src = sSrcHd;        // if the element is an <img> replace it's [src]
            } else {                        // eveything else gets background-image
                imgElm.style.backgroundImage = "url({0})".format(sSrcHd);
            }
        }
    };

    /*********************************************************************************************
    * mojo initialization
    *********************************************************************************************/
    // handles waiting for all dependency promises to load before executing not already ran functions        
    $(function () {
        $.each(mc.events.ready, function (i, e) { $.when.apply($, e.waitFor).then(e.f); });
        mc.events.readyFired = true;
    });
    $(window).on('load', function () {
        $.each(mc.events.load, function (i, e) { $.when.apply($, e.waitFor).then(e.f); });
        mc.events.loadFired = true;
    });
    $(window).on('resize', function () {
        $.each(mc.events.resize, function (i, e) { $.when.apply($, e.waitFor).then(e.f); });
        mc.events.resizeFired = true;
    });

    // overwrite the mc.on functionaliy to handle event registrations after jQuery document[ready|load|resize] events
    var fnSaveCallbackLoadDep = mc.on;
    mc.on = function (e, d, f) {
        var c = fnSaveCallbackLoadDep(e, d, f);         // call the previosuly overwritten function 
        if (mc.events[e + 'Fired']) {                 // e: ready|load|resize jQuery on events
            $.when.apply($, c.waitFor).then(c.f);           // wait for all promises to resolve and execute the function
        }
        return c;
    };

    /*********************************************************************************************
    * Parse out all name-value pairs from the current querystring
    * Usage: mc.queryString['name'] 
    *********************************************************************************************/
    mc.parseQueryString = function (url) {
        // Use the current url if one wasnt provided
        var sUrl = url || document.URL;

        // make an object with the key/value pairs from the querystring
        var oUrl = {};
        sUrl.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
            oUrl[key] = decodeURIComponent(value.split('#')[0]);
        });

        return oUrl;
    };
    mc.queryString = mc.parseQueryString();

    // Function version which wraps the prototype call.
    mc.getFriendlyUrl = function (str) { return str.asFriendlyUrl(); };

    /*********************************************************************************************
    * Utility methods for the location.hash 
    *********************************************************************************************/
    mc.hash = {
        seperator: ',',
        // returns an array of hashes or an object of argument to hash
        // ex: mc.hash.get() -> ['hash1','hash2']
        // ex: mc.hash.get('arg1', 'arg2') -> { arg1: 'hash1', arg2: 'hash2' } 
        get: function () {
            var aArgs = Array.prototype.slice.call(arguments),
                aHashes = location.hash.slice(1).split(mc.hash.seperator),
                oHash = (aArgs.length > 0) ? mc.hash._merge(aArgs, aHashes) : null;
            return (oHash) ? oHash : aHashes;
        },
        // sets the location hash
        // ex: mc.hash.set('hash1', 'hash2', 'hash3');
        set: function () {
            location.hash = Array.prototype.slice.call(arguments).join(mc.hash.seperator);
        },
        // sets the location hash with url encoding
        // ex: mc.hash.set('I have spaces');
        encode: function () {
            var aArgs = Array.prototype.slice.call(arguments), aEncodedHashes = [];
            for (var i = 0; i < aArgs.length; i++) { aEncodedHashes[i] = encodeURIComponent(aArgs[i]); }
            location.hash = aEncodedHashes.join(mc.hash.seperator);
        },
        // returns an array of url decoded hash params
        // ex: mc.hash.decode() -> ['I%20have%20spaces'] -> ['I have spaces']
        decode: function () {
            var aHashes = location.hash.slice(1).split(mc.hash.seperator), aEncodedHashes = [];
            for (var j = 0; j < aHashes.length; j++) { aEncodedHashes[j] = decodeURIComponent(aHashes[j]); }
            return aEncodedHashes;
        },
        // private use only, returns an object of index based function arguments and hashes
        // ex: _merge(['arg1', 'arg2'], ['hash1', 'hash2']) -> { arg1: 'hash1', arg2: 'hash2' }
        _merge: function (a, h) {
            var o = null;
            if (a && h) for (var i = 0; i < a.length; i++) { o = o || {}; o[a[i]] = h[i]; }
            return o;
        }
    };

    /*********************************************************************************************
    * Outgoing Links
    * Automatically adds target="_blank" to outgoing links
    *********************************************************************************************/
    mc.outgoingLinks = {
        // an array of domains to ignore (opens the link same tab)
        // supports the following (TLDs, Wildcards, Page Specific):
        // mojoactive.com, *.mojoactive.com, mojoactive.com/page123
        ignoreDomains: ['*.wasd.org'],
        newTab: true,
        showPopup: false,
        checkLinks: function () {
            $('a:not([href*="' + document.domain + '"])')
                // filter out anything without an href
                .filter(function () { return $(this).attr('href') })
                // filter out internal links and non-links (tel, javascript:void, #, etc...)
                .filter(function () {
                    if (RegExp(/(tel|javascript:void|mailto)/).test($(this).attr('href'))) return false;
                    var hrefLead = $(this).attr('href').charAt(0);
                    return hrefLead != '.' && hrefLead != '#' && hrefLead != '/';
                })
                // filter out ignored domains
                .filter(function () {
                    var href = $(this).attr('href').trim();
                    for (var i = 0; i < mc.outgoingLinks.ignoreDomains.length; i++) {
                        if (mc.outgoingLinks.matchDomain(mc.outgoingLinks.ignoreDomains[i], href)) return false;
                    }
                    return true;
                })
                // add the target blank and popup (if enabled)
                .each(function () {
                    if (mc.outgoingLinks.newTab) $(this).attr('target', '_blank');
                    if (mc.outgoingLinks.showPopup) $(this).attr('data-mc-prompt-leave', true);
                });
            // watch for popup click events (if enabled)
            if (mc.outgoingLinks.showPopup) {
                $(document).on('click', '[data-mc-prompt-leave="true"]', function (e) {
                    e.preventDefault();
                    mc.outgoingLinks.popupAction($(this));
                })
            }
        },
        popupAction: function (elm) {
            // customize this per site, please don't use window.confirm
            // this is used for testing purposes
            var href = elm.attr('href')
            var result = confirm('You are leaving our site. Are you sure you want to do this?');
            if (result) window.open(href);
        },
        matchDomain: function (pattern, url) {
            // helper function to match domains to regex/glob types
            var matchUrl;
            if (pattern[0] === '*') { matchUrl = pattern.substring(1); }
            if (pattern.length !== 0 && pattern[pattern.length - 1] === '*') { matchUrl = pattern.substring(0, matchUrl.length - 1); }
            if (pattern[0] != '*') { matchUrl = pattern; }
            return url.indexOf(matchUrl) !== -1;
        }
    }
    mc.outgoingLinks.checkLinks();

    /*********************************************************************************************
    * Template Binder
    * Returns an html string by binding data to a template with built in plugins and iterators
    *
    * Example (Basic):      mc.template.run($('#template'), [data...]);
    * Example (Advanced):   mc.template.run($('#template'), [data...], function(key, value) { return value; });
    *
    * Run Params:
    * @param {string|jQuery} template the html template.
    * @param {array|object} data the data you wish to bind to the template
    * @param {function} irerator a callback function that returns a key and value of each iteration
    *
    * Plugins
    * You can add custom plugins to modify data before it renders to the template.
    *
    * Example:      mc.template.addPlugin('moment', function(value, pattern) { return moment(value).format(pattern); })
    * Description:  Adds a plugin with moment to format dates
    * @param {string}   pipe the name of the pipe: { Date | PIPE_NAME <-- }
    * @param {function} fn the callback function to preform the modifications. Returns the following:
            @param {any} value the data value { Date <-- | PIPE_NAME }
            @param {any} pattern the item after the ":" of the pipe: { Date | PIPE_NAME:PATTERN <-- }
    *********************************************************************************************/
    mc.template = {
        plugins: {},
        plugins: function () { return Object.keys(this.plugins) },
        addPlugin: function (pipe, fn) { this.plugins[pipe] = { pipe: pipe, fn: fn }; },
        run: function (template, data, iterator) {
            // saftey checks
            if (!template && !data) { console.warn('mc.template', 'missing template and data'); return false; }
            if (!template) { console.warn('mc.template', 'missing a template string or jquery selector'); return false; }
            if (!data) { console.warn('mc.template:', 'missing data'); return false; }

            // handle to data and the return value
            var oRetVal = '';
            var aList = (Array.isArray(data)) ? data : [data];

            // adds support for jquery selector or string
            template = (typeof (template) != 'string') ? $(template).html() : template;

            // bind data to the template
            // includes, plugins, iterators and template replacements
            aList.forEach(function (o) {
                var tempTemplate = template;
                tempTemplate.match(/{([^}]+)}/g).forEach(function (p) {
                    var placeholder = p.replace(/{/g, '').replace(/}/g, '').trim();
                    var value = o[placeholder];
                    if (!value) value = '';
                    var oPipe = mc.template._parsePipe(placeholder);
                    if (oPipe && o[oPipe.name] && mc.template.plugins[oPipe.pipe]) { value = mc.template.plugins[oPipe.pipe].fn(o[oPipe.name], oPipe.pattern); }
                    value = (iterator) ? iterator(placeholder, value) : value;
                    tempTemplate = tempTemplate.replace(p, value);
                });
                oRetVal += tempTemplate;
            });

            // return the html back
            return oRetVal;
        },
        _parsePipe: function (placeholder) {
            // helper function to parse pipes back to a usable form
            var oPipe = null;
            if (!placeholder || (typeof (placeholder) != 'string')) return null;
            if (placeholder.indexOf('|') > -1) {
                oPipe = {};
                oPipe.name = placeholder.split('|')[0].trim();
                oPipe.pipe = placeholder.split('|')[1].trim();
                if (placeholder.split('|')[1].indexOf(':') > -1) {
                    var pipeParts = placeholder.split('|')[1].split(':');
                    oPipe.pipe = pipeParts[0].trim();
                    oPipe.pattern = pipeParts[1].trim().replace(/'/g, '');
                }
            }
            return oPipe;
        }
    }
    // Avaiable Template Plugins
    mc.template.addPlugin('debug', function (value, pattern) { console.log('value: ' + value, '\npattern: ' + pattern); return value; });
    mc.template.addPlugin('moment', function (value, pattern) { return moment(value).format(pattern); });
    mc.template.addPlugin('uppercase', function (value, pattern) { return typeof value === 'string' ? value.toUpperCase() : value; });
    mc.template.addPlugin('lowercase', function (value, pattern) { return typeof value === 'string' ? value.toLowerCase() : value; });
    mc.template.addPlugin('capitalize', function (value, pattern) { return typeof value === 'string' ? value.charAt(0).toUpperCase() + value.slice(1) : value; });
    mc.template.addPlugin('truncate', function (value, pattern) { return typeof value == 'string' ? value.length <= pattern ? value : value.slice(0, pattern - 3) + '...' : value; });
    mc.template.addPlugin('truncateWords', function (value, pattern) { return typeof value == 'string' ? Number(pattern) < value.split(/[ \t]/).length ? value.split(/[ \t]/).slice(0, Number(pattern)).join(' ').trim() + '...' : value : value; });
    mc.template.addPlugin('trim', function (value, pattern) { return typeof value == 'string' ? value.trim() : value; });
    mc.template.addPlugin('join', function (value, pattern) { return Array.isArray(value) ? value.join(', ').trim() : value; });
    mc.template.addPlugin('wrapIf', function (value, pattern) { return (value) ? pattern.replace('~', value) : value });

    /*********************************************************************************************
    * Utility method for a loading image over a selector
    * Example 1: mc.loader.show() -> shows loading gif over the entire body 
    * Example 2: mc.loader.show('.panel') -> shows loading gif over the passed in selector 
    *********************************************************************************************/
    mc.loader = {
        _tmplImage: '<div class="mojo-loader-img"><img src="/images/loading.gif"></div>',
        _tmplBackdrop: '<div class="mojo-loader-backdrop" style="height:{0}px;width:{1}px"></div>',
        _parseSelector: function (oSel) {
            oSel = oSel || 'body';
            return (typeof (oSel) == 'string') ? $(oSel) : oSel;
        },
        show: function (oSel) {
            oSel = mc.loader._parseSelector(oSel);
            oSel.each(function (i, o) { $(o).append(mc.loader._tmplBackdrop.format($(o).innerHeight(), $(o).innerWidth())).append(mc.loader._tmplImage); });
        },
        hide: function (oSel) {
            oSel = mc.loader._parseSelector(oSel);
            oSel.find('.mojo-loader-backdrop, .mojo-loader-img').remove();
        }
    };

    /*********************************************************************************************
    * Bootstrap Modal utility
    *********************************************************************************************/
    mc.modal = {
        templates: {
            'mc': `<div tabindex="-1" class="modal fade" id="{sId}" role="dialog">
                        <div class="modal-dialog my-1" style="max-width: 1102px;">
                            <div class="modal-content">
                                <div class="modal-header border-gray p-2">
                                    <div class="text-center font-weight-bold text-mc">Market<span class="text-gray">Carpenter <small>{mc.platform.version}</small></span></div>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div class="modal-body position-relative p-0">{sContent}</div>
                            </div>
                        </div>
                    </div>`
        },
        show: function (sContent, sTemplate) {
            var sId = 'modal_' + mc.uuid();
            sTemplate = sTemplate || mc.modal.templates.mc;
            sTemplate = sTemplate.replace('{sId}', sId).replace('{mc.platform.version}', mc.platform.version).replace('{sContent}', sContent);
            $('body').append(sTemplate);

            var oModal = $(`#${sId}`);
            oModal.modal({ backdrop: 'static', keyboard: false, show: true }).on('hidden.bs.modal', function () {
                oModal.modal('dispose');
                oModal.remove();
            });
        },
        showIframe: function (sUrl) {
            var iHeight = mc.globals.windowDimensions.height - 60;
            var sFrameId = 'iFrame_' + mc.uuid();
            this.show(`
                <div class="mc-loading"></div><div class="mc-no-click"></div>
                <iframe id="${sFrameId}" src="${sUrl}" height="${iHeight}px" width="100%" frameborder="0"></iframe>
            `);

            $(`#${sFrameId}`).on('load', function () {
                $('.mc-loading,.mc-no-click').remove();
            });
        }
    };

    /*********************************************************************************************
    * Convenience handle for creating simple carousels
    *********************************************************************************************/
    mc.makeCarousel = function (selector, options) {
        mc.ready(['owl-carousel'], function () { $(selector).addClass('owl-carousel').owlCarousel({ items: 1, nav: true, dots: false, ...options }); })
    }
    mc.ready(function () { if ($('.mc-carousel').length) { mc.makeCarousel('.mc-carousel'); } });

    /*********************************************************************************************
    * Utility method for creating options for an HTML select element
    *********************************************************************************************/
    mc.createSelectOptions = function (sSel, aData, sVal, sText, bPlaceholder) {
        if (!sSel || !aData || !sVal || !sText) return 'Missing arguments... you must pass the following: sSel, aData, sVal, sText';
        var sOptions = '';
        var $sel = (typeof (sSel) == 'string') ? $(sSel) : sSel;
        if (bPlaceholder) $sel.append('<option selected value="">Please Select...</option>');
        $.each(aData, function (i, o) { sOptions += ('<option value="{0}">{1}</option>').format(o[sVal], o[sText]); });
        $sel.append(sOptions);
    };

    /*********************************************************************************************
    * Utility method for preloading images (accepting a string or array of strings)
    *********************************************************************************************/
    mc.preloadImg = function (sUrl) {
        var aImg = (typeof sUrl === 'string') ? [sUrl] : sUrl;
        $(aImg).each(function () {
            $('<img/>')[0].src = this;
        });
    }

    /*********************************************************************************************
    * Scrolls to a section of the page, also reacts to on page load or hash change.
    *********************************************************************************************/
    mc.scrollTo = {
        prefix: 'sp-',
        run: function (query) {

            let el;
            if (query.indexOf(this.prefix) != -1) {
                el = $(query.replace(this.prefix, '#'))
            } else if ($(query).length) {
                el = $(query)
            }

            if (el) {
                $('html, body').animate({ scrollTop: el.offset().top }, 500)
            }
        },
        scrollChange: function () {
            mc.scrollTo.run(mc.hash.get()[0]);
        }
    };

    window.addEventListener('hashchange', mc.scrollTo.scrollChange);
    mc.scrollTo.scrollChange();

    /*********************************************************************************************
    * Scroll To functionality on element click
    *********************************************************************************************/
    mc.ready(function () {
        $('[data-scroll-to]').click(function () {
            const to = $(this).data('scroll-to');
            console.log('scrolling to', to)
            mc.scrollTo.run(to);
        });
    });

    /*********************************************************************************************
    * Number Counter
    *********************************************************************************************/
    mc.counter = {
        items: [],
        attr: 'data-counter',
        duration: 3000,
        easing: 'swing',
        init: function () {
            $('[' + this.attr + ']').each(function () {
                var elm = $(this);
                var oItem = { elm: elm, text: elm.text().replace(/[0-9,]/g, ''), top: elm.offset().top - window.innerHeight, start: 0, end: parseInt(elm.text().replace(/,/g, '')), dir: elm.attr(mc.counter.attr) }
                mc.counter.items.push(oItem);
                if (oItem.dir == 'up') { elm.text(0); }
            });
            setTimeout(function() { mc.counter.watch() }, 1500);
        },
        watch: function () {
            var onScroll = function() {
                var scrollTop = $(window).scrollTop();
                mc.counter.items.forEach(function (item) {
                    if ((scrollTop >= item.top && !item.done)) {
                        mc.counter.animate(item);
                        item.done = true;
                    }
                });
            }
            $(window).scroll(onScroll)
            onScroll();
        },
        animate: function (item) {
            $({ countNum: (item.dir == 'up') ? item.start : item.end }).animate({ countNum: (item.dir == 'up') ? item.end : item.start }, {
                duration: mc.counter.duration,
                easing: mc.counter.easing,
                step: function () {
                    var num = (item.dir == 'up') ? Math.ceil(this.countNum) : Math.floor(this.countNum);
                    item.elm.text((num.toLocaleString()) + item.text);
                },
                done: function () {
                    item.elm.text((item.end.toLocaleString()) + item.text);
                }
            })
        }
    }
    setTimeout(function() { mc.counter.init() }, 500)

    /*********************************************************************************************
    * Debounce - Useful for implementing behavior that should only happen after a repeated action has completed.
    *********************************************************************************************/
    mc.debounce = function (func, wait, immediate) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };

    /*********************************************************************************************
    * Is Element In Viewport - tells you is an element is in the current viewport
    *********************************************************************************************/
    mc.isElementInViewport = function (el) {
        var rect = el.getBoundingClientRect();
        return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth));
    };

    /*********************************************************************************************
    * Window Resize - keep the mojo globals up to date. Add other code as needed for resize.
    *********************************************************************************************/
    // set the window dimension variables on window resize.
    var fnResize = function () {
        mc.globals.windowDimensions.width = window.innerWidth;
        mc.globals.windowDimensions.height = window.innerHeight;

        // set the current breakpoint
        var deviceWidth = mc.globals.windowDimensions.width;              // get a convenice handle to the current width
        $.each(mc.constants.breakpoints, function (key, value) {          // loop throuh all the breakpoints
            if (deviceWidth >= value.min && deviceWidth <= value.max)       // if the device is in between the breakpoint
                mc.globals.currentBreakpoint = value;                     // set the current breakpoint global
        });
    };
    mc.resize(fnResize);
    fnResize();

    /*********************************************************************************************
     * Lazy Load - A system of classes to allow for lazy, and device specific image loadsing
     *             All Images will load when they are scrolled to, deferring the load unless an
     *             image is needed
     *    To Use - Add one of the following classes and set the data-src attribute on the image tag
     *             rather than setting the src attribute        
     *                   .lazy           - ALL DEVICES           - use for General images
     *                   .lazy-xs        - XS DEVICES ONLY       - use for Mobile Only images
     *                   .lazy-sm        - SM AND UP DEVICES     - use for Desktop Only images
     *                   .no-loading-img - Use this class to prevent loading image from being added
     *   Example - <img class="lazy" data-src="/path-to-image/image-name.jpg" alt="" />
     *      Docs - http://jquery.eisbehr.de/lazy/
     *********************************************************************************************/

    // lazy load all general images and just create handles for xs and sm+ devices
    mc.lazyLoad = {
        loadingImg: '/images/loading.gif',
        all: null, allSelector: '.lazy',
        xs: null, xsSelector: '.lazy-xs',
        sm: null, smSelector: '.lazy-sm',
        noLoadingSelector: '.no-loading-img',
        fnResize: function (bInitialLoad) {
            if (mc.globals.windowDimensions.width <= mc.constants.breakpoints.xs.max) {
                if (mc.lazyLoad.xs == null) {
                    mc.lazyLoad.xs = $(mc.lazyLoad.xsSelector).Lazy({ autoDestroy: false, chainable: false, bind: (bInitialLoad) ? 'load' : 'event' }); // bind to load event or fire immedialy if not initial load
                    $(mc.lazyLoad.xsSelector).not(mc.lazyLoad.noLoadingSelector).attr('src', mc.lazyLoad.loadingImg);
                }
            } else {
                if (mc.lazyLoad.sm == null) {
                    mc.lazyLoad.sm = $(mc.lazyLoad.smSelector).Lazy({ autoDestroy: false, chainable: false, bind: (bInitialLoad) ? 'load' : 'event' }); // bind to load event or fire immedialy if not initial load
                    $(mc.lazyLoad.smSelector).not(mc.lazyLoad.noLoadingSelector).attr('src', mc.lazyLoad.loadingImg);
                }
            }
        }
    };
    // run the lazy load plugin for the "all device" case
    mc.lazyLoad.all = $(mc.lazyLoad.allSelector).Lazy({ autoDestroy: false, chainable: false });
    $(mc.lazyLoad.allSelector).not(mc.lazyLoad.noLoadingSelector).attr('src', mc.lazyLoad.loadingImg);

    // run the lazy load plugin for the device specific images in resize, and call initially
    mc.resize(mc.lazyLoad.fnResize);
    mc.lazyLoad.fnResize(true);
    $('iframe').lazy();

    /*********************************************************************************************
    * Navigation
    *********************************************************************************************/
    // navigation setup code
    mc.ready(function () {
        // sSelector: String selector or object to turn into an accordion nav
        // bIgnoreMobileCheck: true if click code to be fired small and larger devices
        var initAccordionNav = function (sSelector, bIgnoreMobileCheck) {
            // get a handle to the parent UL
            var oUl = $(sSelector),
                sActiveClass = 'active';

            // for each LI, at all depths of the nav tree
            $('li', oUl).each(function (i, oLi) {
                // get a handle to the child UL,
                var oChildUl = $('>ul, >.container>ul, >.container-fluid>ul', oLi);

                // if the UL exists, make the A tag function like an accordion
                if (oChildUl.length == 1) {
                    // handle to the link
                    var oA = $('>a', oLi),
                        oMoreLinks = $('> a > span', oLi).add($('>a:not([href])', oLi));

                    // open the sub UL on click
                    oMoreLinks.click(function (e) {
                        // this is for mobile nav only
                        if (bIgnoreMobileCheck || mc.globals.windowDimensions.width <= mc.constants.breakpoints.md.max) {
                            // get a handle to all visible child ULs in the current nav and loop through them
                            var oUlToHide = $('ul:visible', oUl);

                            oUlToHide.each(function (i, oUlHide) {
                                // only hide the ul if it does not contain this A tag, and don't wait for the animation queue
                                if ($(oUlHide).find(oA).length == 0) {
                                    $(oUlHide).slideUp({ queue: false });
                                    $(oUlHide).closest('li').removeClass(sActiveClass);
                                }
                            });

                            // as long as the user didn't click on the parent li for the currently open list
                            if (oUlToHide.index(oChildUl) == -1) {
                                oChildUl.slideDown({ queue: false });
                                $(oLi).addClass(sActiveClass);
                            }
                        }

                        e.preventDefault();
                        return false;
                    });
                }
            });
        };

        // setup accordian for mobile and sidebar navigation
        initAccordionNav('#primaryNavBar nav');
        initAccordionNav('.nav-primaryCentered .left > ul, .nav-primaryCentered .right > ul');
        initAccordionNav('.secondaryNav > ul', true);

        // Fits the navigation in the viewport. Solves the problem when a nav's ul spans outside of the view port. 
        var fitNavInViewport = function () {
            if (mc.globals.windowDimensions.width > mc.constants.breakpoints.xs.max) {
                $(".navbar-nav li ul").each(function () {
                    var oElm = $(this);
                    oElm.css({ "opacity": 0, "display": "block", "visibility": "hidden" });
                    setTimeout(function () {
                        var leftPos = oElm.offset().left + oElm.width();
                        if (leftPos > mc.globals.windowDimensions.width) {
                            oElm.addClass("dropdown-menu-right");
                        } else {
                            oElm.removeClass("dropdown-menu-right");
                        }
                        setTimeout(function () {
                            oElm.css("opacity", 1).css("display", "none"); // change it back to hidden
                        }, 200);
                    }, 100);
                });
            }
        };
        mc.resize(fitNavInViewport)
        fitNavInViewport();

    });

    /*********************************************************************************************
    * Responsive Tables
    *********************************************************************************************/
    // Description: Applies a bootstrap responsive class around all tables in content areas.
    mc.ready(function () {
        $('#content table').each(function (i, oTbl) {
            // get handles to the page widths
            var iContentWidth = $('#content').width(),
                iTblWidth = $(oTbl).outerWidth(true),
                iTblHeight = $(oTbl).outerHeight(true);

            // if the width of the table is greater than the content area
            if (iTblWidth > iContentWidth) {
                var oWrap = $(oTbl).wrap('<div class="table-responsive"></div>').parent();
                $(oWrap).height(iTblHeight);
            }
        });
    });

    /*********************************************************************************************
    * Emergency Alert
    *********************************************************************************************/
    mc.ready(['cookie'], function () {
        if ($('.mc-emergency').length > 0) {
            if (!Cookies.get('mc-emergency')) {
                $('body').addClass('mc-emergency-open mc-backdrop-show');
                Cookies.set('mc-emergency', true);
            } else {
                $('.mc-emergency-toggle').css({ opacity: 1 });
            }

            $('.mc-backdrop, .mc-emergency .close').click(function () {
                $('body').removeClass('mc-emergency-open mc-backdrop-show');
            });

            $('.mc-emergency-toggle').click(function () {
                $('body').addClass('mc-emergency-open mc-backdrop-show');
            });

            $('#mc-backdrop').click(function () { $('.mc-backdrop, .mc-emergency .close').click() });
        }
    });

    /*********************************************************************************************
    * Background Video
    *********************************************************************************************/
    mc.video = {
        videos: {},
        defaults: { autohide: 1, modestbranding: 0, rel: 0, showinfo: 0, disablekb: 1, enablejsapi: 1, iv_load_policy: 3 },
        ready: false,
        init: (videoId, selector) => {
            const oWrap = $(selector).parent('#mc-video-wrapper-' + videoId);
            mc.video.videos[videoId] = $.extend({}, mc.video.defaults, {
                selector: selector,
                initialized: false,
                height: oWrap.data('height') || 0,
                controls: oWrap.data('controls') == true ? 1 : 0,
                vheight: oWrap.data('vheight'),
                vwidth: oWrap.data('vwidth'),
                autoplay: oWrap.data('autoplay') == true ? 1 : 0,
                mute: oWrap.data('controls') != true ? 1 : 0

            });
            if (videoId && selector) {
                mc.video.ytLoadAPI();
            }
            ;
        },
        ytPlayerReady: (videoId) => {
            if (mc.video.videos[videoId].autoplay) {
                mc.video.videos[videoId].player.loadVideoById(videoId);
            }
            mc.video.rescale(videoId);
            mc.resize(() => { mc.video.rescale(videoId); })
            $(mc.video.videos[videoId].selector).addClass('active');
            $(mc.video.videos[videoId].selector).parent().addClass('active');
            if (!mc.video.videos[videoId].controls) {
                $(mc.video.videos[videoId].selector).parent().prepend(`<div class="mc-video--click"></div>`)
            }
        },
        ytLoadAPI: () => {
            if (!window.YT) {
                var tag = document.createElement('script');
                tag.src = 'https://www.youtube.com/player_api';
                var fTag = document.getElementsByTagName('script')[0];
                fTag.parentNode.insertBefore(tag, fTag);
            }
        },
        add: (videoId) => {
            mc.video.videos[videoId].controls = (mc.globals.currentBreakpoint.name == 'xs') ? 1 : mc.video.videos[videoId].controls;

            mc.video.videos[videoId].player = new YT.Player(mc.video.videos[videoId].selector.replace('#', ''), {
                events: {
                    'onReady': (e) => { mc.video.ytPlayerReady(videoId) },
                    'onStateChange': (e) => {
                        if (e.data == 0 && mc.video.videos[videoId].autoplay) {
                            mc.video.videos[videoId].player.loadVideoById(videoId);

                        }
                    }
                },
                playerVars: mc.video.videos[videoId]
            });
        },
        rescale: (videoId) => {
            var w = $(mc.video.videos[videoId].selector).parent('.mc-video-wrapper').width(), vh = w / mc.video.videos[videoId].vwidth * mc.video.videos[videoId].vheight;
            mc.video.videos[videoId].player.setSize(w, vh);
            if (vh > mc.video.videos[videoId].height && mc.video.videos[videoId].height > 0) {
                $(mc.video.videos[videoId].selector).parent('.mc-video-wrapper').css({ 'height': mc.video.videos[videoId].height + 'px' });
            }
            else {
                $(mc.video.videos[videoId].selector).parent('.mc-video-wrapper').css({ 'height': vh + 'px' });
            }
        },
        getId: (url) => {
            var ID = ''; url = url.replace(/(>|<)/gi, '').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/); if (url[2] !== undefined) { ID = url[2].split(/[^0-9a-z_\-]/i); ID = ID[0]; } else { ID = url; } return ID;
        },

    }
    // global function the YouTube API will call when loaded
    window.onYouTubePlayerAPIReady = () => { Object.keys(mc.video.videos).forEach(k => { if (!mc.video.videos[k].initialized && (mc.video.videos[k].autoplay || mc.globals.currentBreakpoint.name == 'xs')) { mc.video.add(k); } }); }




    mc.ready(['bootstrap'], function () {                               // Load Bootstrap, then
        $('[data-toggle="collapse"]').collapse();                       // Init Bootstrap collapse functionality 

        $('.mc-accordion .card-header').each(function () { $(this).html($(this).html() + '<i class="fal fa-plus float-right"></i>') });
        $('.mc-accordion .card-header').on('click', function () {       // Init MarketCarpenter Acordian functionality 
            $(this).next().collapse('toggle');
            $(this).parent().toggleClass('show');
        });
        // var sModal = '<div class="modal fade" role="dialog"><div class="modal-dialog modal-dialog-centered" role="document"><div class="modal-content"><div class="modal-header display-4">{0}<button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="fal fa-times float-right"></i></button></div><div class="modal-body">{1}</div></div></div>';
        // $('.mc-modal').on('click', function () {
        //     console.log('modal click')                         // Init MarketCarpenter Modal functionality 
        //     var sHeader = $('.card-header', $(this)).html(),
        //         sContent = $('.card-body', $(this)).html(),
        //         oModal = $(sModal.format(sHeader, sContent));
        //     $('body').append(oModal);
        //     $(oModal).modal('show');
        // });
    });

    /*********************************************************************************************
    * Sticky Sidebar
    *********************************************************************************************/
    mc.ready(function () {
        $(document).on('scroll', function () {
            $('.mc-sticky-sidebar').removeClass('opened');
        });
        $('.mc-sticky-sidebar').on('mouseenter', function () {
            $('.mc-sticky-sidebar').addClass('opened');
        });
    });


    /*********************************************************************************************
    * MarketCarpenter Analytics 
    *********************************************************************************************/
    mc.ready(['analytics'], mc.noop); // add a callback here to handle specific tracking needs

    /*********************************************************************************************
    * Error Reporting Setup
    *********************************************************************************************/
    mc.getScript('https://resources.mojoactive.com/Scripts/error-reporting.2.0.min.js');

    /*********************************************************************************************
    * UserWay 
    *********************************************************************************************/
    // mc.ready(['userway'], mc.noop); // add a callback here to handle specific tracking needs

    /*********************************************************************************************
    * Google Translate
    *********************************************************************************************/
    // $('.navAction-translate').on('click',function() {
    //     var elm =  $(this);
    //     var se = $(".goog-te-combo");
    //     var obj = $('#google_translate_element');


    //     if (mc.globals.currentBreakpoint.name == 'xs') {
    //         se.show();
    //         obj.toggle();
    //         se[0].size = 1;

    //         if (elm.hasClass('opened')) {
    //             elm.html('Translate')
    //             elm.removeClass('opened');
    //         } else {
    //             elm.html('Close')
    //             elm.addClass('opened');
    //         }

    //     } else {

    //         if (elm.hasClass('opened')) {
    //             elm.html('Translate<span class="more"><i class="fal fa-angle-down"></i></span>')
    //             elm.removeClass('opened');
    //         } else {
    //             elm.html('Close')
    //             elm.addClass('opened');
    //         }

    //         se.show();
    //         obj.toggle();
    //         se[0].size = 20;
    //     }

    // });

    // $(".goog-te-combo").on("change", function () {
    //     var se = $(this);
    //     se.hide();
    // });

    // window.googleTranslateElementInit = function () {
    //     new google.translate.TranslateElement({ pageLanguage: 'en', autoDisplay: false }, 'google_translate_element');
    // }
    // mc.ready(['translate'],mc.noop);

    /*********************************************************************************************
    * Image Pooling Functionality
    *********************************************************************************************/
    mc.image = {
        pool: {
            available: {},
            used: {}
        }
    }


    // http://localhost:42219/custom-tools/form/update.ashx?mode=read&guid=f16a1540-002f-403a-970b-659a4047390d


    if (mc.queryString.u) {
        if ($('#FrmId44').length > 0 || $('#FrmId45').length > 0) {

            mc.loader.show();

            // make call to the api
            var guid = mc.queryString.u;

            $.ajax({
                url: '/custom-tools/form/update.ashx?mode=read&guid=' + guid,
                success: function (json) {
                    mc.loader.hide()
                    if (json) {
                        var btnSubmit = $('.mc-form').find('[type="submit"]');
                        var txtReps = $('.mc-form').find('[title="Representative"]');

                        // disable most form fields
                        $('.mc-form').find('label, input, textarea, select').prop('disabled', true).css({ opacity: 0.5 });
                        $('.mc-form').find('input[type="text"], input[type="email"]').val("*************")
                        btnSubmit.prop('disabled', false).css({ opacity: 1 });


                        // enable representives
                        $('[name="txtFName"]').val(json.Company);
                        $('[name="fileCertificateOfInsurance"]').prop('disabled', false).css({ opacity: 1 });
                        $('[name="fileCertificateOfInsurance"]').closest('.form-group').find('label').prop('disabled', false).css({ opacity: 1 });
                        txtReps.prop('disabled', false).css({ opacity: 1 }).val(json.Representative);

                        $('.mc-form').before("<div class='form-editing-disclaimer'><i class='fas fa-info-circle'></i><strong>You already filled out this form.<br>Please update Attendees and Certificate of Insurance fields.</strong></div>")

                        // unbind the normal form click
                        btnSubmit.unbind().click(function (e) {
                            e.stopImmediatePropagation();
                            e.preventDefault();

                            var formData = new FormData();
                            formData.append('Representative', txtReps.val())
                            formData.append('id', parseInt($('.mc-form').attr('id').replace('FrmId', '')))

                            var filesUploads = $('input[type="file"]');
                            if (filesUploads.length > 0) {
                                $.each(filesUploads, function (i, item) {
                                    var oBaseFileUpload = $(item).get(0);
                                    if (oBaseFileUpload.files.length) {
                                        if ($.inArray(oBaseFileUpload.id, formData.keys()) !== -1) {
                                            formData.delete(oBaseFileUpload.id);
                                        }
                                        formData.append(oBaseFileUpload.id, oBaseFileUpload.files[0]);
                                    }
                                });
                            }

                            mc.ajax({
                                cache: false,
                                url: '/custom-tools/form/update.ashx?mode=update&guid=' + guid,
                                method: "POST",
                                enctype: "multipart/form-data",
                                processData: false,
                                contentType: false,
                                data: formData,
                                success: function (json) {
                                    console.log(json)
                                    if (json.success) {
                                        window.location.href = json.redirect;
                                    }
                                }
                            })

                        });

                    }
                }
            })

        }
    }


})();
